<template>
  <div>
      <b-card no-body v-if="isEditMode">
        <b-tabs small card align="center">
          <!-- Add your b-tab components here -->
          <template v-slot:tabs-end>
            <b-nav-item href="#" @click="() => {}" :active="currentTab === index"
              v-for="(variant, index) in variants" :key="index">
              <b-badge variant="primary" class="mr-1">{{index+1}}</b-badge>
              <b-button class="mr-1" variant="outline-primary" @click="setSelectedTab(index)">
                <em class="fas fa-lg fa-question"></em>
              </b-button>
              <b-button variant="outline-danger"
                        @click="deleteChosenVariant(index)">
                <em class="fas fa-lg fa-times"></em>
              </b-button>
            </b-nav-item>
            <b-nav-item>
              <b-button class="mr-1" variant="primary"
                        @click="addVariant">
                <em class="fas fa-lg fa-plus"></em>
              </b-button>
            </b-nav-item>
          </template>
          <div v-if="variants && variants.length" class="m-3">
            <wysiwyg-text-editor dataType="subSectionTextTestVariants"
                                 :currentVariant="currentTab"/>
          </div>
        </b-tabs>
      </b-card>
    <div v-else>
      <h5>Выберите вариант(ы) ответа</h5>
      <div v-for="(variant, index) in variants" :key="index">
        <div class="d-inline-block mr-2">
          <b-button v-if="!isEditMode && (chosenTabs.indexOf(index) === -1)"
                    v-b-tooltip.hover title="Выбрать ответ"
                    variant="outline-primary" @click="addChosenTab(index)">
            <em class="fas fa-lg fa-check"></em>
          </b-button>
          <b-button variant="primary"
                    v-if="!isEditMode && (chosenTabs.indexOf(index) !== -1)"
                    v-b-tooltip.hover title="Убрать выбор ответа"
                    @click="deleteChosenTab(index)">
            <em class="fas fa-lg fa-check"></em>
          </b-button>
        </div>
        <div class="d-inline-block mb-2" style="width: calc(100% - 60px);">
          <b-collapse :id="'variant-'+ index" visible >
            <b-card>
              <p class="card-text" v-html="variants[index]"></p>
            </b-card>
          </b-collapse>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import WysiwygTextEditor from '@/components/content/edit/WysiwygTextEditor.vue'

export default {
  name: 'ChoiceVariantTestSubsection',
  components: {
    WysiwygTextEditor
  },
  props: {
    isEditMode: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters({
      variants: 'education/getVariantsForTest',
      subsection: 'education/getSubsection',
      isTestingMode: 'test/isTestingMode',
      isTestReviewMode: 'educationStudentsManagement/getTestReviewMode',
      solvedByStudent: 'educationStudentsManagement/getSolvedByStudent',
      test: 'test/getTest'
    })
  },
  data() {
    return {
      currentTab: 0,
      chosenTabs: []
    }
  },
  mounted() {
    this.updateTabs()
  },
  methods: {
    ...mapActions({
      addSubsectionTextTestVariant: 'education/addTextTestVariant',
      deleteSubsectionTextTestVariant: 'education/deleteTextTestVariant',
      updateUpdater: 'contentManager/updateUpdater'
    }),
    ...mapMutations({
      setSubsectionTextTestVariant: 'education/setSubsectionTextTestVariant'
    }),
    setSelectedTab(id) {
      const beforeUpdate = this.currentTab
      this.currentTab = id
      this.$nextTick(() => {
        this.currentTab = beforeUpdate
        this.$nextTick(() => {
          this.currentTab = id
        })
      })
    },
    addChosenTab(id) {
      this.chosenTabs.push(id)
    },
    deleteChosenTab(id) {
      if (this.chosenTabs.indexOf(id) !== -1) {
        this.chosenTabs.splice(this.chosenTabs.indexOf(id), 1)
      }
    },
    addVariant() {
      this.updateUpdater()
      this.addSubsectionTextTestVariant('').then(() => {
        if (this.variants.length === 1) {
          this.currentTab = 0
        }
        // this.setSelectedTab(this.variants.length - 1)
      })
    },
    deleteChosenVariant(index) {
      this.updateUpdater()
      this.deleteSubsectionTextTestVariant(index).then(() => {
        this.currentTab = 0
      })
    },
    updateTabs() {
      const subsectionId = this.subsection && this.subsection.id
        ? this.subsection.id : this.$route.params.subsectionId
      if (this.isTestingMode) {
        const answer = this.$cookies.get(this.$cookies.keys().find((k) => k.includes(`test_${this.$route.params.sectionId}_${subsectionId}`)))
        if (answer) {
          this.chosenTabs = JSON.parse(answer).map((a) => a - 1)
        } else {
          this.chosenTabs = []
        }
      } else if (this.isTestReviewMode) {
        const { answer } = this.solvedByStudent
          .find((sbs) => Number(sbs[0])
            === this.test.subSections
              .find((ss) => ss.id === Number(subsectionId)).task.id)[1]
        if (answer) {
          this.chosenTabs = answer.map((a) => a - 1)
        } else {
          this.chosenTabs = []
        }
      } else {
        this.chosenTabs = []
        this.setSelectedTab(this.currentTab)
      }
    }
  },
  watch: {
    chosenTabs(value) {
      this.$emit('changedSelectedTabs', value)
    },
    variants() {
      this.updateTabs()
    }
  }
}
</script>

<style scoped>

</style>
